import React from 'react';
import CarMarks from '../../containers/CarMarks/CarMarks';

const CarMarksPage = () => {
  return <CarMarks />;
};

export default CarMarksPage;
